export function keyValues(key) {
    return `
        query {
            keyValue(key: "${key}") {
                value
            }
        }
    `;
}

export function allKeyValues(blob) {
    return `
        query {
            allKeyValues(keyLike: "${blob}") {
                nodes {
                    key
                    value
                }
            }
        }
    `;
}
